
import common from './en/common';
import auth from './en/auth';
import airports from './en/airports';
import profiles from './en/profiles';
import reviews from './en/reviews';
import home from './en/home';
import settings from './en/settings';
import inventory from './en/inventory';
import navigation from './en/navigation';

export default {
  ...common,
  ...auth,
  ...airports,
  ...profiles,
  ...reviews,
  ...home,
  ...settings,
  ...inventory,
  ...navigation,
  
  // Film hand check translations
  "film_hand_check": "Film Hand Check",
  "hand_check_guide": "Film Hand Check Guide",
  "request_hand_check": "How to Request a Hand Check",
  "film_hand_check_success": "Film Hand Check Success Rate",
  "hand_check_tips": "Hand Check Tips",
  "x_ray_damage": "X-Ray Damage Prevention",
  "airport_security_guide": "Airport Security Guide for Film",
  "scanner_damage": "Scanner Damage Information",
  
  // Light meter translations
  "light_meter": "Light Meter",
  "camera_permission_required": "Camera Access Required",
  "camera_permission_description": "We need access to your camera to measure light for proper exposure settings.",
  "grant_camera_access": "Grant Camera Access",
  "camera_access_error": "Camera Access Error",
  "camera_permission_denied": "Camera permission was denied. Please enable camera access in your device settings.",
  "camera_not_supported": "Your device doesn't support camera access",
  "aperture": "Aperture",
  "shutter_speed": "Shutter Speed",
  "light_value": "Light Value",
  "mobile_only_feature": "Mobile Device Only Feature",
  "light_meter_mobile_only_message": "The light meter is only available on mobile devices with camera support.",
  "max_locks_reached": "You can only lock 2 settings at once",
  "min_locks_required": "At least one setting must remain locked",
  "freeze_frame": "Freeze Frame",
  "unfreeze_frame": "Unfreeze Frame",
  "switch_camera": "Switch Camera",
  "only_one_camera": "Only one camera detected",
  
  // Ambient Light Sensor translations
  "ambient_light_sensor": "Ambient Light Sensor",
  "sensor_active": "Using light sensor",
  "sensor_inactive": "Using camera",
  "sensor_unavailable": "Light sensor unavailable",
  "sensor_permission_denied": "Light sensor permission denied",
  "light_sensor_reading": "Light Sensor Reading",
  "illuminance": "Illuminance (lux)"
}
